import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

import {ConnectionIconComponent} from './connection-icon.component';

@NgModule({
  declarations: [ConnectionIconComponent],
  imports: [
    CommonModule,
    MatIconModule,
  ],
  exports: [ConnectionIconComponent]
})
export class ConnectionIconModule { }
